export enum BoxShape {
  rectangle,
  circle,
}
